import _styled from "@emotion/styled-base";
import { fade } from '@swp/colors';
import layout from './layout';
export var Name = _styled("label", {
  target: "egtqez40"
})({
  name: "zuwdt7",
  styles: "display:none;color:var(--color-main-1);font:inherit;"
});
var baseInput = "\n  border:0;\n  box-sizing: border-box;\n  display: inline-block;\n  font: inherit;\n  width: 100%;\n  margin:0;\n  outline:0;\n  padding: 0.9em 1.4em;\n  font-size: inherit;\n  letter-spacing: inherit;\n";
export var Input = _styled("input", {
  target: "egtqez41"
})(baseInput, " background-color:transparent;");
export var BtnBox = _styled("label", {
  target: "egtqez42"
})({
  name: "cxicow",
  styles: "font-size:inherit!important;display:block;"
});
export var Btn = _styled("button", {
  target: "egtqez43"
})();
export var TextareaPoint = _styled("div", {
  target: "egtqez44"
})({
  name: "8gkxox",
  styles: "padding-bottom:3em;"
});
export var Textarea = _styled("textarea", {
  target: "egtqez45"
})(baseInput, " height:150px;");
export var Point = _styled("div", {
  target: "egtqez46"
})({
  name: "1groj4",
  styles: "padding-bottom:1.2em;"
});
export var StyledContactForm = _styled("form", {
  target: "egtqez47"
})("width:100%;display:inline-block;font-family:var(--font1);&.--center{text-align:center;}&.--justify{text-align:justify;}&.--left{text-align:center;@media screen and (min-width:", function (props) {
  return props.theme.globalMobile;
}, "){text-align:left;}}&.--right{text-align:center;@media screen and (min-width:", function (props) {
  return props.theme.globalMobile;
}, "){text-align:right;}}", function (props) {
  return props.layout && layout[props.layout] ? layout[props.layout](props.theme) : '';
}, " .no-placeholder{", Name, "{display:block;}}", function (props) {
  switch (props.styleFlag) {
    case 2:
      return "\n          " + Input + ",\n          " + Textarea + " {\n            border: 2px solid " + props.theme.variables['color-variable-1'] + ";\n            background-color: transparent;\n          }\n        ";

    case 3:
      return "\n          " + Input + ",\n          " + Textarea + " {\n            background-color: var(--color-main-2);\n            box-shadow: 0 2px 16px 0 rgba(0,0,0,0.12);\n          }\n        ";

    default:
      return "\n          " + Input + ",\n          " + Textarea + " {\n            background-color: " + fade(props.theme.variables['color-variable-1'], 0.08) + ";\n          }\n        ";
  }
}, " &.--shape1{", Btn, ",", Input, ",", Textarea, "{border-radius:4px;}}&.--shape3{", Btn, ",", Input, ",", Textarea, "{border-radius:10px;}}&.--shape4{", Btn, ",", Input, "{border-radius:20em;padding:0.9em 1.8em;}", Textarea, "{border-radius:1.8em;padding:0.9em 1.8em;}}");